import script from "./AdminRoleCell.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRoleCell.vue?vue&type=script&setup=true&lang=js"

import "./AdminRoleCell.vue?vue&type=style&index=0&id=c553f800&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c553f800"]])

export default __exports__